var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.572C23.122 4.998 22.167 5.282 21.167 5.41C22.191 4.708 22.911 3.611 23.237 2.305C22.316 2.915 21.302 3.339 20.217 3.552C19.351 2.621 18.12 2 16.742 2C14.08 2 12 4.08 12 6.742C12 7.117 12.045 7.48 12.13 7.827C8.163 7.647 4.564 5.082 2.207 1.808C1.64 2.97 1.33 4.321 1.33 5.772C1.33 7.819 2.379 9.631 3.833 10.745C3.091 10.721 2.389 10.52 1.773 10.188V10.233C1.773 12.961 3.628 15.176 6.125 15.647C5.749 15.74 5.36 15.791 4.956 15.791C4.669 15.791 4.389 15.771 4.117 15.733C4.716 17.931 6.654 19.57 8.996 19.61C7.276 21.213 5.035 22.006 2.658 22.006C2.292 22.006 1.93 21.983 1.572 21.94C3.932 23.604 6.824 24.5 9.927 24.5C16.737 24.5 21.295 18.982 21.295 13.067L21.282 12.562C22.198 11.982 22.98 11.205 23.558 10.305C24.142 9.397 24.513 8.383 24.652 7.265C25.154 6.689 25.5 5.972 25.5 5.18C25.499 5.039 25.48 4.897 25.441 4.758C26.055 4.137 26.554 3.393 26.912 2.562C26.357 3.032 25.722 3.422 25.032 3.705C25.75 3.192 26.348 2.563 26.775 1.865C26.122 2.344 25.415 2.77 24.672 3.12C24.103 2.521 23.407 2.046 22.618 1.729C22.069 2.176 21.472 2.583 20.846 2.939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.53c45d6a22be33deba3e357866749802.svg";
export { ForwardRef as ReactComponent };